import Admins from "views/admin/admins";
import Contacts from "views/admin/contacts";
import Users from "views/admin/users";
import AddDetails from "views/admin/addDetails";
import ContactForm from "views/admin/contacts/contactForm";
import UserForm from "views/admin/users/userForm";
import AdminForm from "views/admin/admins/adminForm";
import {
  MdOutlineShoppingCart,
  MdBarChart,
  MdPerson,
  MdLock,
} from "react-icons/md";

const routes = [
  {
    name: "Contacts",
    layout: "/admin",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "contacts",
    component: <Contacts />,
  },
  {
    name: "Users",
    layout: "/admin",
    path: "users",
    icon: <MdPerson className="h-6 w-6" />,
    component: <Users />,
    excludeForUser: true,
  },
  {
    name: "Admins",
    layout: "/admin",
    path: "admins",
    icon: <MdLock className="h-6 w-6" />,
    component: <Admins />,
    excludeForAdmin: true,
    excludeForUser: true,
  },
  {
    name: "Contact Form",
    layout: "/admin",
    path: "contacts/contactForm",
    icon: <MdOutlineShoppingCart className="h-6 w-6" />,
    component: <ContactForm />,
    secondary: true,
    excludeForUser: true,
  },
  {
    name: "User Form",
    layout: "/admin",
    path: "users/userForm",
    icon: <MdOutlineShoppingCart className="h-6 w-6" />,
    component: <UserForm />,
    secondary: true,
    excludeForUser: true,
  },
  {
    name: "Admin Form",
    layout: "/admin",
    path: "admins/adminForm",
    icon: <MdOutlineShoppingCart className="h-6 w-6" />,
    component: <AdminForm />,
    secondary: true,
    excludeForAdmin: true,
    excludeForUser: true,
  },
  {
    name: "contactForm Id",
    layout: "/admin",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "contacts/contactForm/:id",
    component: <ContactForm />,
    secondary: true,
    // excludeForUser :true
  },
  {
    name: "UserForm Id",
    layout: "/admin",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "users/userForm/:id",
    component: <UserForm />,
    secondary: true,
    excludeForUser: true,
  },
  {
    name: "AdminForm Id",
    layout: "/admin",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "admins/adminForm/:id",
    component: <AdminForm />,
    secondary: true,
    excludeForAdmin: true,
  },
  {
    name: "Add Utils",
    layout: "/admin",
    path: "addDetails/",
    icon: <MdPerson className="h-6 w-6" />,
    component: <AddDetails />,
    excludeForUser: true,
    excludeForAdmin: true,
  },
];
export default routes;
